import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Link, Redirect } from "react-router-dom";
import { observer, inject } from 'mobx-react';
import { Layout, Icon, Card, Form, Input, Button, Spin, Modal, notification } from 'antd';
import CustomFooter from './CustomFooter';

import { AuthStoreContext } from './AppContexts';

const { Header, Content } = Layout;

const ONLOGIN_DEFAULT_REDIRECT = '/';

/*****************************************
 *	LOGIN
 * ***************************************/
@observer
class LoginComponent extends React.Component {
	static contextType = AuthStoreContext;

	state = {
		hasAltBg: (Math.random() > 0.5)
	}

	render() {
		if (this.context.isLogged){
			let { from } = this.props.location.state || { from: { pathname: ONLOGIN_DEFAULT_REDIRECT } };
			return <Redirect to={from} />
		}
		return (
			<Layout style={{ minHeight: '100vh' }} className={ 'login-layout' + (this.state.hasAltBg ? ' alt-bg' : '') }>
				<div className='layout-top'>
					<h1>Enoteca Ricciardi Shipping Manager</h1>
				</div>
				<Content>
					{ this.context.initializing ?
						<div className="initializing-container">
							<Spin indicator={<Icon type="loading" style={{ fontSize: 128 }} spin />}
								tip="Attendi, stiamo verificando che tu sia ancora autenticato..." />
						</div>
						: <LoginForm authStore={this.context} />
					}
				</Content>
				<CustomFooter />
			</Layout>
		);
	}
}

const LoginForm = Form.create({
	name: 'login-form'
})(observer((props) => {
	const { getFieldDecorator } = props.form;

	let handleSubmit = (e) => {
		//console.log('internal handle submit');
		e.preventDefault();
		props.form.validateFields((err, values) => {
			if (!err) {
				props.authStore.login(values).catch( () => {
					notification.error({
						message: 'Login non riuscito'
						,description: 'Verifica che l\'email e la password siano corretti'
						,duration: 5
					});
				});
			}
		});
	};

	return (
		<Form className="login-form" layout='vertical' onSubmit={handleSubmit}>
			<Form.Item label='Email'>
			{ getFieldDecorator('email', {
				rules: [ { required: true, message: 'Inserisci la tua email/username' }
				]
			})( <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} type="email" placeholder="mail@example.com" />) }
			</Form.Item>
			<Form.Item label='Password'>
			{ getFieldDecorator('password', {
				rules: [ { required: true, message: 'Inserisci la password!' } ]
			})( <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="password" />) }
			</Form.Item>
			<div className="clearfix">
				<Link className="login-form-forgot" to="/password-forgot">Forgot password</Link>
			</div>
			<Form.Item>
				<Button className="submit" loading={props.authStore.loggingIn} type="primary" htmlType="submit">Log In</Button>
			</Form.Item>
		</Form>
	);
}));


/*****************************************
 *	PASSWORD RESET REQUEST
 * ***************************************/
const RequestPasswordResetComponent = Form.create({ name: 'request-password-reset' })(
class extends React.Component {
	static contextType = AuthStoreContext;

	state = {
		submitted: false
		,loading: false
	}

	handleSubmit = (e) => {
		e.preventDefault();
		this.props.form.validateFieldsAndScroll( (err, values) => {
			if (err) {
				return;
			}
			console.log('Received values of form: ', values);
			this.setState({ loading: true });
			this.context.requestPasswordReset(values).then( () => {
				notification.success({
					message: 'Success'
					,description: 'Your request was submitted successfully. If your email address is in our systems, you\'ll receive a reset link shortly'
					,duration: 5
				});
				this.setState({ loading: false, submitted: true });
			} ).catch( (err) => {
				console.error(err);
				this.setState({ loading: false });
				notification.error({
					message: 'Error'
					,description: 'Cannot submit your request. Please try again.'
					,duration: 8
				});
			} );
		});
	}

	render() {
		const { getFieldDecorator } = this.props.form;
		if (this.state.submitted){
			return <Redirect to="/login" />
		}
		return (
			<Layout style={{ minHeight: '100vh' }} className="login-layout request-password-reset">
				<div className='layout-top'>
					<h1>Enoteca Ricciardi Shipping Manager Password Reset</h1>
				</div>
				<Content>
					<Form className='request-password-reset-form' onSubmit={this.handleSubmit}>
						<Form.Item label="E-mail">
							{getFieldDecorator('email', {
								rules: [{
									type: 'email', message: 'The input is not valid E-mail!',
								}, {
									required: true, message: 'Please insert your E-mail!',
								}]
							})( <Input type="email" /> )}
						</Form.Item>
						<div className="clearfix">
							<Link className="request-password-reset-login" to="/login">Login</Link>
						</div>
						<Form.Item>
							<Button className="submit" type="primary" htmlType="submit" loading={this.state.loading}>Reset Password</Button>
						</Form.Item>
					</Form>
				</Content>
				<CustomFooter />
			</Layout>
		);
	}
});

/*****************************************
 *	PASSWORD RESET FORM
 * ***************************************/
const PasswordResetComponent = Form.create({
	name: 'password-reset'
})(
class extends React.Component {
	static contextType = AuthStoreContext;

	state = {
		submitted: false
		,loading: false
		//,token: this.props.match.params.token
		,token: null
		,fields: {
			'password': ''
			,'password-confirm': ''
		}
	}

	componentDidMount() {
		this.setTokenByQueryParameters();
	}

	getTokenByQueryParameters() {
		let params = new URLSearchParams(this.props.location.search);
		console.log(`Access token: ${params.get('access_token')}`)
		return params.get('access_token');
	}

	setTokenByQueryParameters() {
		this.setState({ token: this.getTokenByQueryParameters() || null });
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.location.search != this.props.location.search){
			console.log('Location search changed, recomputing token...');
			this.setTokenByQueryParameters();
		}
	}

	onChangePassword = (evt) => {
		let fields = { ...this.state.fields, password: evt.target.value };
		this.setState({ fields: fields });
		this.props.form.setFieldsValue(fields);
	}
	onChangeConfirm = (evt) => {
		let fields = { ...this.state.fields, 'password-confirm': evt.target.value };
		this.setState({ fields });
		this.props.form.setFieldsValue(fields);
	}
	compareToFirstPassword = (rule, value, callback) => {
		if (this.state.fields['password-confirm'] && this.state.fields['password-confirm'] != this.state.fields.password){
			return callback('The passwords don\'t match');
		}
		callback();
	}

	handleSubmit = (e) => {
		e.preventDefault();
		this.props.form.validateFieldsAndScroll( (err, values) => {
			if (err) {
				console.error(err);
				return;
			}
			console.log('Received values of form: ', values);
			this.setState({ loading: true });
			this.context.resetPassword({
				password: this.state.fields.password
				,token: this.state.token
			}).then( () => {
				this.setState({ loading: false, submitted: true });
				notification.success({
					message: 'Success'
					,description: 'Password reset successful. You can log in now'
					,duration: 5
				});
			}).catch( (err) => {
				console.error(err);
				this.setState({ loading: false });
				notification.error({
					message: 'Error'
					,description: 'Error resetting the password. Please try again'
					,duration: 5
				});
			});
		});
	}

	render() {
		const { getFieldDecorator, getFieldProps } = this.props.form;
		if (this.state.submitted){
			return <Redirect to="/login" />
		}
		return (
			<Layout style={{ minHeight: '100vh' }} className="login-layout password-reset">
				<div className='layout-top'>
					<h1>Enoteca Ricciardi Shipping Manager Password Reset</h1>
				</div>
				<Content>
					<Form className='password-reset-form' onSubmit={this.handleSubmit}>
						<Form.Item label='Password'>
							<Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
								type="password" placeholder="password" 
								{ ...getFieldProps('password', {
									rules: [ { required: true, message: 'Please input your Password!' } ]
								})}
								value={this.state.fields.password}
								onChange={this.onChangePassword} />
						</Form.Item>
						<Form.Item label='Confirm Password'>
							<Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
								type="password" placeholder="password" 
								{ ...getFieldProps('password-confirm', {
									rules: [
										{ required: true, message: 'Please re-type your Password!' }
										, { validator: this.compareToFirstPassword }
									]
								})}
								value={this.state.fields['password-confirm']}
								onChange={this.onChangeConfirm} />
						</Form.Item>
						<Form.Item>
							<Button className="submit" type="primary" htmlType="submit" loading={this.state.loading}>Reset Password</Button>
						</Form.Item>
					</Form>
				</Content>
				<CustomFooter />
			</Layout>
		);
	}
});

export { LoginComponent, RequestPasswordResetComponent, PasswordResetComponent };
